:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 5);
}

gz-chip {
  width: fit-content;
  --content-max-width: 400px;
  margin-left: calc(var(--spacer) / 2 - 8px);
}

.hidden {
  display: none;
}

gz-form-field::part(form-field-label),
.files-title,
.file-size {
  font-size: var(--small-button-font-size);
  text-transform: uppercase;
  font-weight: 600;
  color: var(--chart-300-icon-buttons);
}

gz-form-field::part(form-field-label) {
  width: 50%;
}

.files-title-container {
  color: var(--black-layout-700-primary);

  &.error {
    color: var(--red-alert-500-severe);

    gz-title {
      opacity: 1;
    }
  }
}

.chip-container {
  display: flex;
  flex-direction: row;
  align-items: center;

  gz-title {
    padding-left: calc(var(--spacer) * 2);
    color: var(--black-layout-700-primary);
    opacity: 0.5;
    width: auto;

    &.error {
      color: var(--red-alert-500-severe);
      opacity: 1;
    }

    &.duplicate {
      color: var(--red-alert-500-severe);
      opacity: 1;
      text-transform: uppercase;
    }
  }
}
